<template>
  <div class="app-header">
    <div class="header-container">
      <!-- Logo区域 -->
      <div class="logo" @click="$router.push('/')">
        <img src="@/assets/home.jpg" alt="德財家居網" class="logo-text" />
      </div>

      <!-- 汉堡菜单按钮 (仅在移动端显示) -->
      <div class="hamburger-menu" @click="toggleMobileMenu" v-if="isMobileView">
        <el-icon><Menu /></el-icon>
      </div>

      <!-- 导航菜单 -->
      <nav :class="['nav-menu', { 'mobile-menu-open': isMobileMenuOpen && isMobileView }]">
        <!-- 关闭按钮 (仅在移动端菜单打开时显示) -->
        <div class="mobile-menu-close" @click="toggleMobileMenu" v-if="isMobileMenuOpen && isMobileView">
          <el-icon><Close /></el-icon>
        </div>
        <!-- <router-link to="/shoes" class="nav-item" @click="closeMobileMenuOnNavigate">精品搜尋</router-link> -->
        <router-link to="/overview" class="nav-item" @click="closeMobileMenuOnNavigate">商品總覽</router-link>
        <!-- <router-link to="/collections" class="nav-item" @click="closeMobileMenuOnNavigate">潮流趨勢</router-link> -->
        <!-- <a href="https://app.city-wallet.com/trade" target="_blank" rel="noopener noreferrer" class="nav-item ignore" @click="closeMobileMenuOnNavigate">CT Point</a> -->
        <!-- <router-link to="/about" class="nav-item" @click="closeMobileMenuOnNavigate">關於我們</router-link> -->
      </nav>

      <!-- 右侧操作区域容器 -->
      <div class="right-actions-container">
        <!-- 語言切換器 -->
        <div class="language-switcher-container">
          <!-- <language-switcher /> -->
        </div>
        <!-- 用户操作区域 -->
        <div class="user-actions">
          <template v-if="isAuthenticated">
            <el-icon class="action-icon" @click="goToUserProfile" title="我的主頁"><User /></el-icon>
            <el-icon class="action-icon" @click="goToCart" title="購物車"><ShoppingCart /></el-icon>
            <span @click="handleLogout" class="logout-text">退出</span>
          </template>
          <template v-else>
            <span class="login-link" @click="goToLogin">登入</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue' // 引入 onBeforeUnmount
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
// import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import authService from '../../services/auth'
import { User, ShoppingCart, Menu, Close } from '@element-plus/icons-vue' // 導入 Menu 和 Close 圖標

export default {
  name: 'AppHeader',
  components: {
    // LanguageSwitcher,
    User,
    ShoppingCart,
    Menu, // 註冊汉堡菜单图标
    Close // 注册关闭图标
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const { t } = useI18n()
    const activeIndex = computed(() => router.currentRoute.value.path)

    const username = ref("")
    const isAuthenticated = ref(false)
    const userRole = ref("user")
    const isMobileMenuOpen = ref(false)
    const isMobileView = ref(window.innerWidth <= 992) // 初始判断是否为移动视图

    const authStatus = computed(() => store.getters['auth/authStatus']);
    
    const updateMobileView = () => {
      isMobileView.value = window.innerWidth <= 992 // 阈值可以调整
      if (!isMobileView.value) {
        isMobileMenuOpen.value = false; // 在桌面视图下总是关闭移动菜单
      }
    }

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value
    }

    const closeMobileMenuOnNavigate = () => {
      if (isMobileView.value) {
        isMobileMenuOpen.value = false;
      }
    }

    const visibleRoutes = computed(() => {
      return router.options.routes.filter(route => !route.meta?.hidden)
    })

    const goToLogin = () => {
      router.push({ name: 'Login' })
      closeMobileMenuOnNavigate()
    }

    const goToUserProfile = () => {
      router.push({ name: 'MyHome' })
      closeMobileMenuOnNavigate()
    }

    const goToCart = () => {
      router.push({ name: 'Cart' })
      closeMobileMenuOnNavigate()
    }

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm(
          '确定要退出登录吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        const result = await authService.logout()
        if(result){
          ElMessage.success("退出成功")
          store.commit('auth/setAuthStatus', false);
          store.commit('auth/setUserInfo', null); 
          isAuthenticated.value = false
          username.value = ""
          await router.push({ name: 'Home' });
          window.location.reload();
          // router.push({ name: 'Login' })
        }
      } catch {
        // 取消时不操作
      }
      closeMobileMenuOnNavigate()
    }

    onMounted(async () => {
      window.addEventListener('resize', updateMobileView)
      updateMobileView(); // 初始化检查
      try {
        const result = await authService.getCurrentUser()
        store.commit('auth/setUserInfo', result);
        store.commit('auth/setAuthRole', result.role);
        const displayedUserInfo = computed(() => store.getters['auth/currentUserInfo']);
        if(result){
          isAuthenticated.value = true
          store.commit('auth/setAuthStatus', true);
          username.value = result.email
          userRole.value = result.role
        }
      }catch(error){
        // ElMessage.error(error)
      }
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateMobileView)
    })

    return {
      activeIndex,
      visibleRoutes,
      t,
      isAuthenticated,
      username,
      userRole,
      isMobileMenuOpen,
      isMobileView, // 暴露给模板
      toggleMobileMenu, // 暴露给模板
      closeMobileMenuOnNavigate, // 暴露给模板
      goToLogin,
      goToUserProfile,
      goToCart,
      handleLogout
    }
  }
}
</script>

<style scoped lang="scss">
.app-header {
  width: 100%;
  background: rgba(255, 255, 255, 0.616);
  z-index: 1000; // 基础 z-index，确保在页面大部分内容之上
  backdrop-filter: blur(12px);
  position: relative; // 为子元素的 z-index 和 fixed 定位提供上下文
}

.header-container {
  margin: 0 auto;
  padding: 0 32px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  position: relative; // 确保 logo 在移动菜单之下 (如果菜单 z-index 更高)
  z-index: 1;      // 较低的 z-index

  .logo-text {
    height: 40px;
    font-weight: 700;
    color: #1a1a1a;
    letter-spacing: 1px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 60%;
      height: 2px;
      background: linear-gradient(90deg, #409EFF 0%, #7c4dff 100%);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }
  }

  &:hover .logo-text::after {
    transform: scaleX(1);
  }
}

.hamburger-menu {
  display: none;
  cursor: pointer;
  font-size: 24px;
  color: #333;
  padding: 0 10px;
  position: relative; // 确保汉堡按钮在展开的菜单层级问题上可控
  z-index: 1002;     // 比展开的菜单高，确保可以点击来关闭
}

.nav-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin: 0 auto; // 在桌面端居中

  .nav-item {
    color: #000000;
    font-weight: 500;
    font-size: 15px;
    text-decoration: none;
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    white-space: nowrap;

    &:hover {
      color: #000000;
      &::after {
        content: '>';
        position: absolute;
        right: -12px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 12px;
        color: #000000;
      }
    }

    &.router-link-active {
      color: #aed7fd;
    }
  }
}

.right-actions-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  position: relative; // 确保在移动菜单之下
  z-index: 1;      // 较低的 z-index
}

.language-switcher-container {
  margin: 0 16px 0 24px;
}

.user-actions {
  display: flex;
  align-items: center;

  .login-link {
    color: #666;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.3s ease;
    white-space: nowrap;

    &:hover {
      color: #409EFF;
    }
  }

  .action-icon {
    font-size: 22px;
    color: #606266;
    cursor: pointer;
    margin-left: 18px;
    transition: color 0.3s ease;

    &:hover {
      color: #409EFF;
    }

    &:first-child {
       margin-left: 0;
    }
  }
  .action-icon + .action-icon {
    margin-left: 18px;
  }

  .logout-text {
    margin-left: 20px;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.3s ease;
    white-space: nowrap;
     &:hover {
      color: #409EFF;
    }
  }
}

// 响应式断点 (例如 992px)
@media (max-width: 992px) {
  .header-container {
    padding: 0 16px;
    // position: relative; // AppHeader 已经是 relative 了
  }

  .logo {
    margin-right: 0;
  }
  .logo .logo-text {
      height: 35px;
  }

  .nav-menu {
    display: none;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 70%;
    max-width: 300px;
    height: 100vh;
    background: rgba(255, 255, 255, 0.98); // 背景可以更不透明一些
    backdrop-filter: blur(10px);
    padding: 70px 20px 20px; // 顶部留出关闭按钮/header高度空间
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.15);
    z-index: 1001; // **关键：高于 logo 和 right-actions-container，但可以低于 hamburger-menu 本身**
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    gap: 15px;
    align-items: flex-start;
    justify-content: flex-start;
    overflow-y: auto; // 如果菜单项过多，允许垂直滚动

    &.mobile-menu-open {
      display: flex;
      transform: translateX(0);
    }

    .nav-item {
      padding: 12px 0;
      width: 100%;
      font-size: 16px;

      &:hover::after {
        content: none;
      }
      &.router-link-active {
        color: #409EFF;
        font-weight: bold;
      }
    }
  }

  .mobile-menu-close {
    position: absolute;
    top: 22px; // 根据 header 高度和视觉效果调整
    right: 20px;
    font-size: 28px; // 增大关闭按钮，方便点击
    cursor: pointer;
    color: #333;
    z-index: 1002; // 确保关闭按钮在菜单面板之上
    padding: 5px; // 增加点击区域
  }

  .hamburger-menu {
    display: flex;
    align-items: center;
    // margin-left: auto; // 由 right-actions-container 的 margin-left: auto 控制整体位置
  }

  .right-actions-container {
     margin-left: auto; // 将右侧操作整体推到最右边 (在汉堡按钮之后)
     // z-index: 1; // 已在外部设置
  }

  .language-switcher-container {
    margin: 0 10px 0 0;
  }

  .user-actions {
    .action-icon {
      font-size: 20px;
      margin-left: 12px;
    }
    .logout-text {
      font-size: 13px;
      margin-left: 12px;
    }
    .login-link {
        font-size: 14px;
    }
  }
}

@media (max-width: 480px) {
    .logo .logo-text {
      height: 30px;
    }
    .language-switcher-container {
        display: none;
    }
    .nav-menu { // 针对非常小的屏幕，可以考虑让菜单宽度更小
        width: 80%;
        max-width: 260px;
    }
    .user-actions {
        .logout-text {
        }
        .login-link {
            font-size: 13px;
        }
         .action-icon {
            margin-left: 10px;
        }
    }
}
</style>